import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux'
import Snackbar from '@material-ui/core/Snackbar'
import qs from 'qs'
import UtmUtils from '../utils/utmUtils'
import {
  selectDisplayPopUpState,
  selectSellerNetworkError,
  setDisplayPopUpState,
} from '../reducers/callSlice'
import {
  selectIsNotificationVisible,
  selectNotificationMessage,
  setLikeMessageReceivedHandler,
  setIsNotificationVisible,
  showOnCloseMessageCall,
  setDisplayPopUpMessageHandler,
  setRemoteLikeAnimation,
  setExternalReactionReceivedHandler,
  setExternalReaction,
  setQuickAdd,
  setQuickAddReceivedHandler,
  setChatCooldownMessageHandler,
  setChatCooldown,
  setEventFinishedMessageHandler,
} from '../reducers/uiSlice'
import { PIPBackground } from './GJKit/PIPBackground'
import { usePIP } from '../hooks/usePIP'
import { isIOS } from 'react-device-detect'
import { CallLayout } from './Call/Layout'
import { Streaming } from './Call/Streaming'
import { PhoneContainer } from './Kit/Container'
import styled from 'styled-components'
import { Cards as CallCards } from './Call/Cards'
import { CheckoutIframeDialog } from './dialogs/CheckoutIframeDialog'
import CustomDialog from './dialogs/customDialog'
import { useTranslation } from 'react-i18next'
import { PoorNetworkDialog } from './dialogs/PoorNetworkDialog'
import { useViews } from 'state'
import { Products } from './Products/Products'
import { useDevices } from '@gojiraf/responsive'
import { usePopUp } from '../hooks/usePopUp'
import { useUtm } from '@gojiraf/useutm'

export default function CallCard({ close }) {
  const { t } = useTranslation()
  const { isDesktop } = useDevices()
  const dispatch = useDispatch()
  const { data: popUpData, setData: setPopUpData } = usePopUp()
  const displayPopUpState = useSelector(selectDisplayPopUpState)
  const sellerNetworkError = useSelector(selectSellerNetworkError)
  const [sellerNetworkErrorAcknowledged, setSellerNetworkErrorAcknowledged] = useState(false)
  const { isEnabled } = usePIP()
  const { state } = useViews()
  const queryParams = qs.parse(window.location.search, { ignoreQueryPrefix: true })
  const { utm_medium } = UtmUtils.getUtmObject(queryParams)
  const { showUIComponents } = useUtm(utm_medium)

  useEffect(() => {
    function popstateHandler() {
      closeCall()
    }

    window.addEventListener('popstate', popstateHandler)
    return function () {
      window.removeEventListener('popstate', popstateHandler)
    }
  }, [])

  const closeCall = () => {
    dispatch(showOnCloseMessageCall())
  }

  const onLikeMessageReceived = () => {
    dispatch(setRemoteLikeAnimation({ remoteLikeAnimation: true }))
  }

  const onExternalReactionReceived = (message) => {
    dispatch(setExternalReaction({ externalReaction: message.reaction }))
  }

  const onQuickAddReceived = (message) => {
    dispatch(setQuickAdd({ quickAdd: message }))
  }

  const onDisplayPopUpMessage = (popUpData, show) => {
    setPopUpData(popUpData)
    dispatch(setDisplayPopUpState(show))
  }

  const handleClose = () => {
    dispatch(setIsNotificationVisible({ isNotificationVisible: false }))
  }

  const onChatCooldownReceived = ({ seconds }) => {
    dispatch(setChatCooldown(seconds))
  }

  const onEventFinishedMessage = () => {
    close()
  }

  useEffect(() => {
    dispatch(setLikeMessageReceivedHandler(onLikeMessageReceived))
    dispatch(setExternalReactionReceivedHandler(onExternalReactionReceived))
    dispatch(setQuickAddReceivedHandler(onQuickAddReceived))
    dispatch(setChatCooldownMessageHandler(onChatCooldownReceived))
    dispatch(setEventFinishedMessageHandler(onEventFinishedMessage))
  }, [dispatch])

  useEffect(() => {
    dispatch(setDisplayPopUpMessageHandler(onDisplayPopUpMessage))
  }, [displayPopUpState])

  const render = () => {
    if (isDesktop) {
      return null
    }

    if (state.matches('main.showingCart') === true) {
      return <Products />
    } else if (state.matches('main.showingOrder') === true) {
      return <CallCards.Checkout />
    } else if (state.matches('main.showingOrderStatus') === true) {
      return <CallCards.CashCheckoutFinish />
    } else if (state.matches('main.showingProducts') === true) {
      return <CallCards.ProductDetail />
    }
  }

  return (
    <>
      <PhoneContainer>
        {isEnabled && !isIOS && <PIPBackground />}
        <CustomDialog
          tittle={t('homePage.phoneContainerCustomDialogTitle')}
          description={t('homePage.phoneContainerCustomDialogDescription')}
          onClose={() => {
            setSellerNetworkErrorAcknowledged(true)
          }}
          isOpen={sellerNetworkError && !sellerNetworkErrorAcknowledged}
        />
        {showUIComponents && <PoorNetworkDialog />}
        <Notification
          open={useSelector(selectIsNotificationVisible)}
          autoHideDuration={3000}
          onClose={handleClose}
          data-test="main-container-notification"
        >
          <span>{useSelector(selectNotificationMessage)}</span>
        </Notification>

        {render}

        <CallLayout popUpData={popUpData} />
        <Streaming />
      </PhoneContainer>
      <CheckoutIframeDialog />
    </>
  )
}

CallCard.propTypes = {
  close: PropTypes.func.isRequired,
}

const Notification = styled(Snackbar)`
  position: absolute;
  left: 0;
  right: 0;
  bottom: unset;
  top: 0;
  z-index: 3;
  background-color: white;
  color: black;
  transform: none;
  padding: 1.5rem 0;
`
